import { TitledVerticalFlexLayout } from '../../features/shared/components/VerticalFixedLayout/VerticalFixedLayout';
import { coreService } from '../../services/core/core-service';
import { FrameworkReportingExecution } from '../../features/framework-reporting/types';
import { Button, Flex } from 'antd';
import {
  RunReportModal,
  RunReportModalProps,
} from '../../features/framework-reporting/components/run-report/run-report';
import { useState } from 'react';
import { FileTextOutlined, ReloadOutlined } from '@ant-design/icons';
import { ReportsTable } from '../../features/framework-reporting/components/table/table';
import { useFrameworkReporting } from '../../features/framework-reporting/hooks/use-framework-reporting';
import { ReportsFilters } from '../../features/framework-reporting/components/filters/filters';
import { FrameworkReportsProvider } from '../../features/framework-reporting/contexts/framework-reportings.context';

export const FrameworkReportingPage = () => {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [predefinedValues, setPredefinedValues] =
    useState<RunReportModalProps['predefinedValues']>(undefined);

  const { refetch } = useFrameworkReporting();

  const handleSuccess = () => {
    refetch();
    setIsReportModalOpen(false);
  };

  const handleDelete = async (record: FrameworkReportingExecution) => {
    await coreService.removeFrameworkReportingExecution(record.id);
    refetch();
  };

  const handleReRun = (record: FrameworkReportingExecution) => {
    setPredefinedValues({
      framework: record.frameworkId,
      type: record.type,
      accounts: record.parameters.accountIds ?? [],
      csmIds: record.parameters.csmIds ?? [],
    });
    setIsReportModalOpen(true);
  };

  return (
    <TitledVerticalFlexLayout
      title={'Reports'}
      titleDescription={
        <Flex justify="space-between" gap="16px" vertical>
          <div style={{ maxWidth: '1000px' }}>
            Run on-demand reports about your Accounts and Team.{' '}
            <a
              href="https://help.update.ai/en/articles/11152215-how-to-run-reports"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#ff6c54', textDecoration: 'underline' }}
            >
              Learn more
            </a>
            .
          </div>

          <Flex gap={8}>
            <Button
              type="primary"
              icon={<FileTextOutlined />}
              onClick={() => setIsReportModalOpen(true)}
            >
              Run New Report
            </Button>

            <Button icon={<ReloadOutlined />} onClick={() => refetch()}>
              Refresh View
            </Button>
          </Flex>
        </Flex>
      }
    >
      <RunReportModal
        open={isReportModalOpen}
        onClose={() => setIsReportModalOpen(false)}
        onSuccess={handleSuccess}
        predefinedValues={predefinedValues}
      />

      <br />

      <ReportsFilters />

      <br />

      <ReportsTable onRerun={handleReRun} onDelete={handleDelete} />
    </TitledVerticalFlexLayout>
  );
};

export const FrameworkReportingWrapper = () => {
  return (
    <FrameworkReportsProvider>
      <FrameworkReportingPage />
    </FrameworkReportsProvider>
  );
};
